import React, { createContext, useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';

export const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [subscriptionStatus, setSubscriptionStatus] = useState(null); // null | active | expired | none
  const [loading, setLoading] = useState(true);
  const [remainingTime, setRemainingTime] = useState(null); // { days, hours, minutes, seconds }

  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const session = await Auth.currentSession();
      const jwt = session.getIdToken().getJwtToken();
      const username = user.username.includes("Google_")
        ? user.attributes.email
        : user.username;
      return [username, jwt];
    } catch {
      return [null, null];
    }
  };

  const fetchSubscription = async () => {
    try {
      setLoading(true);
      const [username, jwt] = await getToken();
      if (!username || !jwt) {
        setSubscriptionStatus("none");
        return;
      }

      const res = await fetch("https://api.quizwizard.net/quiz/getSubscription", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: jwt,
        },
        body: JSON.stringify({ username }),
      });

      const data = await res.json();
      // console.log("fetchSubscription response:", data); // Debug API response
      setSubscriptionStatus(data.status || "none");
      setRemainingTime(data.remaining_time || null);
    } catch (err) {
      // console.error("Error in fetchSubscription:", err);
      setSubscriptionStatus("none");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  // Check subscription status when remainingTime expires
  useEffect(() => {
    if (!remainingTime || subscriptionStatus !== "active") return;

    const interval = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (!prevTime) {
          // console.log("Timer expired, fetching subscription status"); // Debug expiration
          fetchSubscription(); // Call API to update status
          return null;
        }

        let { days, hours, minutes, seconds } = prevTime;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 59;
          hours -= 1;
        }
        if (hours < 0) {
          hours = 23;
          days -= 1;
        }
        if (days < 0) {
          // console.log("Timer expired, fetching subscription status"); // Debug expiration
          fetchSubscription(); // Call API to update status
          return null; // Timer expired
        }
        // console.log("Remaining time:", { days, hours, minutes, seconds }); // Debug timer
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingTime, subscriptionStatus]);

  return (
    <SubscriptionContext.Provider value={{ subscriptionStatus, loading, refreshSubscription: fetchSubscription, remainingTime }}>
      {children}
    </SubscriptionContext.Provider>
  );
};